import * as HttpService from './HttpService'

let namespace = 'users'

let all = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let create = (body, cb, errorCb) => {
    HttpService.post(namespace, body, cb, errorCb)
}

let update = (uuid, body, cb, errorCb) => {
    HttpService.patch(namespace + '/' + uuid, body, cb, errorCb)
}

let remove = (uuid, cb, errorCb) => {
    HttpService.remove(namespace + '/' + uuid, cb, errorCb)
}

let forgotPassword = (params, cb, errorCb) => {
    HttpService.get('forgot-password', params, cb, errorCb)
}

export {
    all,
    create,
    update,
    remove,
    forgotPassword
}



// WEBPACK FOOTER //
// ./src/services/userService.js